import * as Dialog from '@radix-ui/react-dialog';
import ClearIcon from '../icons/ClearIcon';
import api from '../utils/api';
import { useEffect, useState, forwardRef } from 'react';
import LoadingIcon from '../icons/LoadingIcon';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

interface FullScreenImageProps {
  id: string;
}

const FullScreenImage = forwardRef<HTMLDivElement, FullScreenImageProps>(({ id }, ref) => {
  const [image, setImage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  

  useEffect(() => {
    setIsLoading(true); 
    api({
      url: `/image-generation/v1/images/${id}`,
      responseType: 'json'
    }).then((res) => {
      setImage(res.data.url);
      setIsLoading(false);
    });
  }, [id]);

  return (
    <Dialog.Overlay className="fixed inset-0 bg-[#29292999] bg-opacity-60 backdrop-blur-[1.5px] z-[3000] flex overflow-y-auto py-10">
      <Dialog.Content aria-describedby="" className="relative m-auto px-10 z-[3100]" ref={ref}>
        <VisuallyHidden>
          <Dialog.Title>Fullscreen Image</Dialog.Title>
        </VisuallyHidden>
        {!isLoading && (
          <Dialog.Close asChild>
            <button
              type="button"
              className="absolute right-14 top-4 z-10"
              onClick={e => e.stopPropagation()}
            >
              <ClearIcon />
            </button>
          </Dialog.Close>
        )}
        {image && !isLoading ? (
          <img
            src={image}
            alt="Fullscreen"
            className="rounded-[20px] max-h-full max-w-full object-contain"
          />
        ) : (
          isLoading && <LoadingIcon className="w-48 text-[#FEFE17] m-auto" />
        )}
      </Dialog.Content>
    </Dialog.Overlay>
  );
});

// Set display name for easier debugging
FullScreenImage.displayName = 'FullScreenImage';
export default FullScreenImage;
